import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container } from '@mui/material';
import TopHeader from './TopHeader';
import MainContent from './MainContent';
import Content1 from './Content1';
import ListeningActivity from './ListeningActivity';
import ListeningTest from './ListeningTest';
import TopHeader2 from './topheader2';
import Footer from './Footer';
import './App.css';
import SpeeckActivity from './SpeeckActivity';
import SpeeckTest from './SpeeckTest';
import ReadActivity from './ReadActivity';
import ReadTest from './ReadTest';
import WriteTest from './WriteTest';
import WriteActivity from './WriteActivity';
import ScorePage from './ScorePage';


function App() {

  const [audio, setAudio] = useState(new Audio('/audio/wellcome.mp3'));
  const [isPlaying, setIsPlaying] = useState(false);
  const [step, setstep] = useState(1);
  const pagestep = useSelector((state) => state.counter.value);
  const dispatch = useDispatch();
  const nextpage = (newValue) => {
    setstep(newValue);  // Update state based on the value passed from child
  };
  const pageNames = {
    1: 'Main Content',
    2: 'Content 1',
    3: 'LISTENING  ',
    4: 'LISTENING TEST',
    5: 'SPEAKING  ',
    6: 'SPEAKING TEST',
    7: 'READING',
    8: 'READING TEST',
    9: 'WRITING ',
    10: 'WRITING TEST',
    11: 'PRE-ASSESSMENT TEST SCORE'
  };
  const pageset = {
    3: 'Listen_Que',
    6: 'Speek_Que',
    7: 'Read_Que  ',
    8: 'write_Que',

  };


  console.log('pagestep', pagestep);
  return (
    <Container
      maxWidth="md"
      // sx={{ paddingTop: 5 }}
      sx={{
        paddingTop: 5,
        paddingBottom: "100px", // 👈 IMPORTANT
        minHeight: "100vh",
      }}
    >
      <TopHeader2 page_name={pageNames[pagestep]} pageset={pageset[pagestep]} />
      {pagestep === 1 ? (
        <MainContent />
      ) : pagestep === 2 ? (
        <Content1 />
      ) : pagestep === 3 ? (
        <ListeningActivity />
      ) : pagestep === 4 ? (
        <ListeningTest />
      ) : pagestep === 5 ? (
        <SpeeckActivity />
      ) : pagestep === 6 ? (
        <SpeeckTest />
      ) : pagestep === 7 ? (
        <ReadActivity />
      ) : pagestep === 8 ? (
        <ReadTest />
      ) : pagestep === 9 ? (
        <WriteActivity />
      ) : pagestep === 10 ? (
        <WriteTest />
      ) : pagestep === 11 ? (
        <ScorePage />

      ) : null}

      <Footer />
    </Container>
  );

}

export default App;
